export { getFileSizeWithUnit } from "@/utils";
export function isImageUrl(url: string) {
  const ext = url.split("?")[0].split(".").pop();
  const imgExts = [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "bmp",
    "psd",
    "svg",
    "tiff",
    "xmp",
    "webp",
    "dds",
  ];
  return imgExts.includes(ext?.toLowerCase() || "");
}
